import React, { FunctionComponent, useState } from 'react'
import { useIntl } from 'react-intl'

import { Link } from '../../atoms/link/Link'
import { useShouldShowCoverageMessaging } from '../../hooks/useShouldShowCoverageMessaging'
import { BodyTextSize } from '../../styles/typeStyles'
import { tID } from '../../utils/utils'
import { CoverageMessagingModal, CoverageMessagingModalProps } from '../coverageMessagingModal/CoverageMessagingModal'

export interface CoverageMessagingLinkProps extends Omit<
  CoverageMessagingModalProps,
  'setIsModalOpen' | 'isModalOpen'
> {
  isCostMessagingEnabled: boolean
  linkText?: string
  size?: BodyTextSize
  underline?: boolean
  linkColor?: string
  subheaderText?: string
}

export const CoverageMessagingLink: FunctionComponent<CoverageMessagingLinkProps> = ({
  coverageModalTitleText,
  coverageModalContents = [],
  costMessagingModalCoverageInfo = undefined,
  isCostMessagingEnabled,
  trackCoverageModalPress,
  linkText,
  size = BodyTextSize.SMALL,
  underline = true,
  customerName,
  numSessions,
  numberOfSessionByProgram,
  displayVisitsPerIssuePerYear,
  displayVisitsPerIssuePerYearByProgram,
  linkColor,
  subheaderText,
  goToSearchForCare,
}) => {
  const { formatMessage } = useIntl()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const shouldShowCoverageMessaging = useShouldShowCoverageMessaging({
    isCostMessagingEnabled,
    costMessagingModalCoverageInfo,
    coverageModalContents,
  })

  if (!shouldShowCoverageMessaging) {
    return <></>
  }

  return (
    <>
      <Link
        text={
          linkText ||
          formatMessage({
            defaultMessage: 'Understand your coverage',
            description: "Link to open a modal which explains the member's care coverage",
          })
        }
        size={size}
        onPress={() => {
          trackCoverageModalPress(true)
          setIsModalOpen(true)
        }}
        color={linkColor}
        underline={underline}
        testID={tID('CoverageMessagingLink')}
      />
      <CoverageMessagingModal
        isModalOpen={isModalOpen}
        setIsModalOpen={(isOpen) => setIsModalOpen(isOpen)}
        coverageModalTitleText={coverageModalTitleText}
        coverageModalContents={coverageModalContents}
        costMessagingModalCoverageInfo={costMessagingModalCoverageInfo}
        trackCoverageModalPress={trackCoverageModalPress}
        customerName={customerName}
        numSessions={numSessions}
        numberOfSessionByProgram={numberOfSessionByProgram}
        displayVisitsPerIssuePerYear={displayVisitsPerIssuePerYear}
        displayVisitsPerIssuePerYearByProgram={displayVisitsPerIssuePerYearByProgram}
        subheaderText={subheaderText}
        goToSearchForCare={goToSearchForCare}
      />
    </>
  )
}
